/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The OssStsAkVo model module.
   * @module course_standard/model/OssStsAkVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>OssStsAkVo</code>.
   * @alias module:course_standard/model/OssStsAkVo
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>OssStsAkVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/OssStsAkVo} obj Optional instance to populate.
   * @return {module:course_standard/model/OssStsAkVo} The populated <code>OssStsAkVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'endpoint')) {
        obj['endpoint'] = ApiClient.convertToType(data['endpoint'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'accessKeyId')) {
        obj['accessKeyId'] = ApiClient.convertToType(data['accessKeyId'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'accessKeySecret')) {
        obj['accessKeySecret'] = ApiClient.convertToType(data['accessKeySecret'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'securityToken')) {
        obj['securityToken'] = ApiClient.convertToType(data['securityToken'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'url')) {
        obj['url'] = ApiClient.convertToType(data['url'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bucketName')) {
        obj['bucketName'] = ApiClient.convertToType(data['bucketName'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} endpoint
   */
  exports.prototype['endpoint'] = undefined;
  /**
   * @member {String} accessKeyId
   */
  exports.prototype['accessKeyId'] = undefined;
  /**
   * @member {String} accessKeySecret
   */
  exports.prototype['accessKeySecret'] = undefined;
  /**
   * @member {String} securityToken
   */
  exports.prototype['securityToken'] = undefined;
  /**
   * 下载地址
   * @member {String} url
   */
  exports.prototype['url'] = undefined;
  /**
   * @member {String} bucketName
   */
  exports.prototype['bucketName'] = undefined;



  export default exports;
;


